import { connect } from 'react-redux';
import {
  createInfoBanner as createInfoBannerAction,
  createErrorBanner as createErrorBannerAction,
} from 'components/Banner';

import { asyncOnSubmit } from '../helpers';
import Form from './Form';

function mapStateToProps(_, ownProps) {
  return {
    ...ownProps,
  };
}

const mapDispatchToProps = {
  createInfoBanner: createInfoBannerAction,
  createErrorBanner: createErrorBannerAction,
};

function mergeProps(stateProps, dispatchProps) {
  const { onSubmit, ...restStateProps } = stateProps;
  const { createInfoBanner, createErrorBanner } = dispatchProps;

  return {
    ...restStateProps,
    onSubmit: asyncOnSubmit(onSubmit, createErrorBanner, createInfoBanner),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Form);
